module.exports = __webpack_public_path__ + "img/12.eb743b2b.png";